<template>
    <div class="p-5 darker">
        <integrations />
    </div>
</template>

<script>
    import integrations from '@/components/integrations/Integrations.vue'

    export default {
        components:{
            integrations,
        }
    }
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// TabIntegrations.vue?fc7967a4